import type { UserFields } from '@ms/yammer-graphql';

import type { UserHideField } from '../../../state/userHideFields/types';

type ProcessUserHideField = (value: UserFields) => UserHideField;
export const processUserHideField: ProcessUserHideField = ({ id, viewerHasHidden, viewerCanHide }) => ({
  id,
  viewerHasHidden: viewerHasHidden ?? undefined,
  viewerCanHide: viewerCanHide ?? undefined,
});
